import { render, staticRenderFns } from "./NonComplianceSelect.vue?vue&type=template&id=a3ba1e98&"
import script from "./NonComplianceSelect.vue?vue&type=script&lang=js&"
export * from "./NonComplianceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports